import { Badge, BlockStack, Box, Button, Card, Checkbox, Divider, Grid, Icon, Image, InlineGrid, InlineStack, Layout, Modal, Text, TextContainer, TextField } from '@shopify/polaris';
import React, { useCallback, useEffect, useState } from 'react';
import TourGuideImg from '../../../../Asests/Images/tour-guide.png'
import { CircleTickMinor, PlayMajor, SearchMinor } from '@shopify/polaris-icons';
import { DI, DIProps } from '../../../../Core';
import { StepType, useTour } from '../../../Other/tour';
import BUlkUploadImage from '../../../../Asests/Images/BulkUploadTourImage.png'
import { appBridgeRouting } from '../../Panel/index';
import { useTranslation } from 'react-i18next';

const TourGuide = (props: DIProps) => {
    const { t } = useTranslation();
    const [active, setActive] = useState(false);
    // const [value, setValue] = useState('');
    const [startBulkUploadTour, setStartBulkUploadTour] = useState(false)
    const [templateCreated, setTemplateCreated] = useState(false);
    const [loader, setLoader] = useState(false)

    const toggleModal = useCallback(() => setActive((active) => !active), []);
    // const handleChange = useCallback((newValue: string) => setValue(newValue), []);

    const getTourData = async () => {
        setLoader(true)
        await props.di.POST("connector/config/getConfig", {
            group_code: ["tour"],
        }).then((response: any) => {
            if (response.success) {
                let value = response.data.find((a: any) => a.group_code === 'tour')?.value
                if (value?.bulk_upload_tour) {
                    const parts_visited = value?.bulk_upload_tour?.parts_visited ?? 0
                    if (parts_visited === 0) {
                        setTemplateCreated(false)
                    } else {
                        if (value?.templateId && value?.templateId !== '') {
                            setTemplateCreated(true)
                        }
                    }
                } else {
                    setTemplateCreated(false)
                }
            }
            setLoader(false)
            setStartBulkUploadTour(true);
            props.di.globalState.removeLocalStorage(`${props.redux?.user_id}_${props.redux?.current?.target?._id}_filters`);
            setActive(false);
        })
    }

    if (props?.di?.globalState?.get('refreshToken_required')) return <></>

    return (
        <>
            <Card roundedAbove='sm'>
                <BlockStack gap="200">
                    <Grid columns={{ md: 3 }}>
                        <Grid.Cell columnSpan={{ xs: 4, sm: 4, md: 6, lg: 8, xl: 8 }}>
                            <BlockStack gap="200">
                                <InlineStack gap="200" align='start' blockAlign='center'>
                                    <Text variant="headingMd" as="h6">{t("Tour Guides")}</Text>
                                    {/* <Badge tone='attention'>1 New</Badge> */}
                                </InlineStack>
                                <Text as='p' variant='bodyMd' tone='subdued'>{t("Walk through the functionalities of the app and learn essential processes with these steps-by-steps tutorials.")}</Text>
                            </BlockStack>
                        </Grid.Cell>
                        <Grid.Cell columnSpan={{ xs: 2, sm: 2, md: 6, lg: 4, xl: 4 }}>
                            <InlineStack align='center'>
                                <img src={TourGuideImg} alt='Tour Guide' className='mx-w--100' />
                            </InlineStack>
                        </Grid.Cell>
                    </Grid>
                    <Button onClick={toggleModal}>{t("Explore Tours")}</Button>
                </BlockStack>
            </Card>
            {/* modal design */}
            <Modal
                open={active}
                onClose={toggleModal}
                title={t("Tour Guides")}>
                <Modal.Section>
                    <BlockStack gap="500">
                        {/* <TextField
                            label
                            placeholder='Search tours'
                            prefix={<Icon source={SearchMinor} tone="base" />}
                            value={value}
                            onChange={handleChange}
                            autoComplete="off"
                        /> */}
                        <BlockStack gap="400">
                            <InlineStack wrap={true} align='space-between' blockAlign='start' gap="400">
                                <div className='custom-guide--content'>
                                    <BlockStack gap="100">
                                        <InlineStack gap="200" align='start' blockAlign='center'>
                                            <Text variant="headingMd" as="h6">{t("Single Product Upload")}</Text>
                                            {/* <Badge tone='attention'>New</Badge> */}
                                        </InlineStack>
                                        <Text as='p' variant='bodyMd' tone='subdued'>{t("Follow this guide to learn how to upload a single product to Amazon by matching it with an existing listing on Amazon, customizing it, and mapping attributes.")}</Text>
                                    </BlockStack>
                                </div>
                                <Button
                                    icon={<Icon
                                        source={PlayMajor}
                                        tone="base"
                                    />}
                                    onClick={async () => {
                                        props.di.globalState.set('start_tour', 'single_product_upload')
                                        props.di.globalState.removeLocalStorage(`${props.redux?.user_id}_${props.redux?.current?.target?._id}_filters`);
                                        props.di.globalState.set('uploadTour', JSON.stringify({ part: '1' }));
                                        appBridgeRouting("product", props)
                                    }}
                                >{t("Start Tour")}</Button>
                            </InlineStack>
                            <Divider />
                            <InlineStack wrap={true} align='space-between' blockAlign='start' gap="400">
                                <div className='custom-guide--content'>
                                    <BlockStack gap="100">
                                        <Text variant="headingMd" as="h6">{t("Bulk Product Upload")}</Text>
                                        <Text as='p' variant='bodyMd' tone='subdued'>{t("Follow this tutorial to learn how to create a template, assign products to it, and then upload those products to Amazon in bulk using the template.")}</Text>
                                    </BlockStack>
                                </div>
                                <Button
                                    icon={<Icon
                                        source={PlayMajor}
                                        tone="base"
                                    />}
                                    onClick={() => {
                                        getTourData()
                                    }}
                                >{t("Start Tour")}</Button>
                            </InlineStack>
                        </BlockStack>
                    </BlockStack>
                </Modal.Section>
            </Modal>
            {!loader && <BulkUploadTourOverview {...props} start_tour={startBulkUploadTour} templateCreated={templateCreated} setStartBulkUploadTour={setStartBulkUploadTour} />}
        </>
    );
}

export default DI(TourGuide);

const BulkUploadTourOverview = (props: DIProps & { start_tour: boolean, templateCreated: boolean, setStartBulkUploadTour: React.Dispatch<React.SetStateAction<boolean>> }) => {
    const { t } = useTranslation();
    const { setIsOpen, setSteps, isOpen, setCurrentStep } = useTour();
    const [tourPart, setTourPart] = useState(0);
    const [checked, setChecked] = useState(false)

    const endTour = () => {
        props.di.POST('connector/config/saveConfig', {
            data: [
                {
                    data: JSON.parse(
                        JSON.stringify(
                            {
                                bulk_upload_tour: {
                                    parts_visited: 5,
                                },
                                // template_created: false,
                                // templateId: ''
                            }
                        )
                    ),
                    group_code: 'tour',
                },
            ],
        }).then((response: any) => {
            setIsOpen(false);
            props.setStartBulkUploadTour(false)
            props.di.globalState.removeLocalStorage('start_tour');
            if (response.success)
                return;
            props.error(
                t('Failed to end tour')
            );
        });
    }

    const steps: StepType[] = [{
        content: <div style={{ maxWidth: 650 }}>
            <Box padding='500'>
                <BlockStack gap='400'>
                    <InlineStack wrap={false} gap='300'>
                        <Image source={BUlkUploadImage} alt='' />
                        <BlockStack gap='300'>
                            <BlockStack gap='100'>
                                <Text as='p' fontWeight='semibold' variant='headingLg'>{t("Bulk Product Upload Guide")}</Text>
                                <Text as='p'>{t("Learn how to upload multiple products on Amazon at once by following these easy steps:")}</Text>
                            </BlockStack>
                            <BlockStack gap='200'>
                                <InlineStack wrap={false} gap='200'>
                                    <div><Icon source={CircleTickMinor} tone={tourPart === 0 ? 'base' : 'success'} /></div>
                                    <Text as='p'><Text as='strong'>{t("Step 1:")} </Text>{t("Create a Template")}</Text>
                                </InlineStack>
                                <InlineStack wrap={false} gap='200'>
                                    <div><Icon source={CircleTickMinor} tone='subdued' /></div>
                                    <Text as='p'><Text as='strong'>{t("Step 2:")} </Text>{t("Upload products via the Template")}</Text>
                                </InlineStack>
                            </BlockStack>
                        </BlockStack>
                    </InlineStack>
                    {props.templateCreated && <div className='Custom-Polaris-Box'>
                        <Box padding='400' background='bg-surface-active' borderRadius='200'>
                            <Checkbox
                                label={<Text as='strong'>{t("Is your Template ready?")}</Text>}
                                checked={checked}
                                onChange={() => {
                                    setChecked(check => !check);
                                    setTourPart(part => part === 0 ? 1 : 0);
                                    setSteps?.(steps)
                                    setCurrentStep(0);
                                }}
                            />
                            <Text as='p'>{t("If you have already created a template, skip to Step 2.")}</Text>
                        </Box>
                    </div>}
                    {!props.templateCreated && <Text as='p' tone='subdued'>{t("Note: Step 1 may take some time, depending on the number of products in the template. Proceed to Step 2 after the products have been assigned to the template.")}</Text>}
                </BlockStack>
            </Box>
        </div>,
        selector: '',
        footer: (p) => {
            return <Box padding='500' paddingBlockStart='0'>
                <InlineStack align='end' gap='500'>
                    <Button variant='plain' tone='critical' onClick={() => { endTour() }}>{t("End Tour")}</Button>
                    <Button variant='primary' tone='success' onClick={() => {
                        if (tourPart === 0) {
                            p?.nextClick();
                        } else {
                            props?.di.POST('connector/config/saveConfig', {
                                data: [
                                    {
                                        data: JSON.parse(
                                            JSON.stringify(
                                                {
                                                    bulk_upload_tour: {
                                                        parts_visited: 4,
                                                    },
                                                }
                                            )
                                        ),
                                        group_code: 'tour',
                                    },
                                ],
                            }).then((response: any) => {
                                setIsOpen(false)
                                setSteps?.([])
                                setCurrentStep(0);
                                if (response.success) {
                                    props.di.globalState.set('start_tour', 'bulk_upload_2');
                                    props.di.globalState.removeLocalStorage(`${props.redux?.user_id}_${props.redux?.current?.target?._id}_filters`);
                                    appBridgeRouting("product", props)
                                }
                                else props.error(t("Something went wrong"))
                            })
                        }
                    }}>{t("Start with STEP")} {`${tourPart + 1}`}</Button>
                </InlineStack>
            </Box>
        }
    }, {
        content: <div style={{ maxWidth: 400 }}>
            <Box padding="300">
                <BlockStack gap="200">
                    <Text as='h2' variant='headingMd'>{t("Setting")}</Text>
                    <Text as="p">
                        {t("Access")} <Text as='strong'>{t("Settings")}</Text> {t("from the sidebar menu on the left, or click on")} <Text as='strong'>{t("Next")}</Text> {t("button.")}
                    </Text>
                </BlockStack>
            </Box>
        </div>,
        selector: '',
        hideActions: {
            close: false
        },
        footer(p) {
            return <div style={{ maxWidth: 400 }}>
                <Box padding='300'>
                    <InlineStack align='space-between'>
                        <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                        <InlineStack gap='400'>
                            <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                            <Button size='slim' variant='primary' onClick={() => {
                                props?.di.POST('connector/config/saveConfig', {
                                    data: [
                                        {
                                            data: JSON.parse(
                                                JSON.stringify(
                                                    {
                                                        bulk_upload_tour: {
                                                            parts_visited: 1,
                                                        },
                                                    }
                                                )
                                            ),
                                            group_code: 'tour',
                                        },
                                    ],
                                }).then((response) => {
                                    setIsOpen(false)
                                    setSteps?.([]);
                                    setCurrentStep(0);
                                    if (response.success) {
                                        props.di.globalState.set('start_tour', 'bulk_upload_1');
                                        appBridgeRouting("config", props)
                                    }
                                    else props.error(t("Something went wrong"))
                                })
                            }}>{t("Next")}</Button>
                        </InlineStack>
                    </InlineStack>
                </Box>
            </div>
        }
    }]

    useEffect(() => {
        if (props?.start_tour) {
            setIsOpen(true);
            setCurrentStep(0);
            setSteps?.(steps)
        } else {
            setIsOpen(false)
            setSteps?.([])
            setCurrentStep(0);
            props.di.globalState.removeLocalStorage('start_tour');
        }
    }, [props.start_tour])

    useEffect(() => {
        if (isOpen && props?.start_tour) {
            setSteps?.(steps)
        }
    }, [checked])

    return null;
}